import PromotionFrequency from "./PromotionFrequency";
export default PromotionFrequency;
